function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.83102 686.5L0.831025 686.5L0.831025 687.5L1.83102 687.5L1.83102 686.5ZM23.2071 687.207C23.5976 686.817 23.5976 686.183 23.2071 685.793L16.8431 679.429C16.4526 679.038 15.8195 679.038 15.4289 679.429C15.0384 679.819 15.0384 680.453 15.4289 680.843L21.0858 686.5L15.4289 692.157C15.0384 692.547 15.0384 693.181 15.4289 693.571C15.8195 693.962 16.4526 693.962 16.8431 693.571L23.2071 687.207ZM0.830719 0.169921L0.831025 686.5L2.83102 686.5L2.83072 0.169921L0.830719 0.169921ZM1.83102 687.5L3 687.5L3 685.5L1.83102 685.5L1.83102 687.5ZM3 687.5L22.5 687.5L22.5 685.5L3 685.5L3 687.5Z",
  fill: "#B4B8C3"
});

var SvgArrowline2 = function SvgArrowline2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 694,
    viewBox: "0 0 24 694",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowline2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowline2.3545cd35.svg";
export { ForwardRef as ReactComponent };